import { useCallback, useEffect, useState } from "react";

import { useWorklogMissing } from "../../../reactQuery/worklogMissing";
import { getMissingWorklogDialogOpen } from "../utils/worklogMissingUtils";

export function useWorklogMissingDialog() {
  const { worklog, isRefetching } = useWorklogMissing();
  const { responseData, daily_worklog_hours } = worklog?.data?.data || {};
  const [dialog, setDialog] = useState(false);

  useEffect(() => {
    setDialog(getMissingWorklogDialogOpen(responseData));
  }, [isRefetching, responseData]);

  const handleClose = useCallback(() => {
    setDialog(false);
  }, []);

  return {
    dailyWorklogHours: daily_worklog_hours,
    dialog,
    handleClose,
    list: responseData,
  };
}
